import { httpPost, httpDownload } from '../../../../utils/api.utils';
import {
    setDisputeHistoryLogsLoading,
    getDisputeHistoryLogs,
    setDisputeHistoryPageSize,
    resetDisputeHistory,
    setDisputeHistoryColSearchStr
} from '../../../../constants/model-reducers/external/invoice/dispute/dispute-history.settings';

import { DEFAULT_TABLE_RESULT_MODEL, DISPUTE_HISTORY_OBJ as disputeHistoryObj } from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';
import Moment from 'moment';

const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});

const initialState = defaultState();

export const disputeHistoryActions = {
    getDisputeHistoryLogs: (DisputeId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().invoiceDisputeHistory.HistoryTable;
        var formData = {
            DisputeID: DisputeId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers,
            TimeZone: getLocalTimeZone()
        };

        dispatch({
            type: setDisputeHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost('external/dispute/getDisputeHistoryLogs', formData);

        const formattedItems = result.Data.Items.map(item => {
            const formattedItem = { ...item };
            Object.keys(formattedItem).forEach(key => {
                if (key === 'OldValue' || key === 'NewValue') {
                    const objectName = formattedItem['Object'];
                    const value = formattedItem[key];
                    if ((objectName === disputeHistoryObj.mrc || objectName === disputeHistoryObj.annualPotentialSavings || objectName === disputeHistoryObj.annualRealizedSavings
                        || objectName === disputeHistoryObj.potentialsavings || objectName === disputeHistoryObj.realizedSavings) && !isNaN(value)) {
                        const num = parseFloat(value);
                        if (Number.isInteger(num) || String(value).endsWith('.0000')) {
                            formattedItem[key] = num.toFixed(2);
                        }
                    }
                }
            });
            return formattedItem;
        });

        dispatch({
            type: getDisputeHistoryLogs,
            historyTable: {
                ...result,
                Data: {
                    ...result.Data,
                    Items: formattedItems,
                },
            },
            isLoadingTable: false
        });
    },
    resizeDisputeHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setDisputeHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    setDisputeHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().invoiceDisputeHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setDisputeHistoryColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },
    extractDisputeHistoryLogs: (DisputeId) => async (dispatch, state) => {
        const { Headers } = state().invoiceDisputeHistory.HistoryTable;
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const dealName = sessionStorage.getItem('DealName');
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        var filename = `ATEM ${dealName} Dispute History - ${formattedTimeZoneDate}`;
        var formData = {
            DisputeID: DisputeId,
            Headers: Headers,  
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/dispute/getExtractDisputeHistoryLogs', formData) 
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
    resetDisputeHistory: () => (dispatch, state) => {
        dispatch({
            type: resetDisputeHistory
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setDisputeHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getDisputeHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setDisputeHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setDisputeHistoryColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetDisputeHistory:
            return initialState;
        default:
            return state;
    }
}